import type { SgwtTranslationMessages } from '../../../common/i18n';
import cs from './cs.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import pt from './pt.json';
import ru from './ru.json';
import zh from './zh.json';

export const translationMessages: Record<string, SgwtTranslationMessages> = { en, fr, de, es, it, ja, pt, ru, zh, cs };
